import { IAdapter } from "./adapter";

/**
 * Generic adapter
 * transform DTO to ViewModel
 */
export abstract class AbstractAdapter<DTO, T> implements IAdapter<DTO, T> {
  get classRef(): new (model?: Partial<DTO>) => T {
    return Reflect.getMetadata("classRef", this);
  }

  adapt(item: DTO) {
    return new this.classRef(item);
  }

  adaptArray(items: DTO[]): T[] {
    return items.map<T>(dto => this.adapt(dto));
  }

  adaptDTO(item: T) {
    return {
      ...item,
    } as unknown as DTO;
  }

  adaptDTOAray(items: T[]) {
    return items.map(vw => this.adaptDTO(vw));
  }
}
